import { Select } from '@scripsteam/scrips-signal-ds';
import type { LabVendor } from '@/billing/services/use-lab-vendors';
import { labVendorOptionLabel } from '@/scheduling/services/use-lab-desk-vendors';

/**
 * Lab vendor filter for the lab desk (PROD-2653). "All vendors" maps to
 * `undefined`, so the list request omits `labVendorId`.
 */

const ALL = '__all__';

interface LabVendorFilterProps {
  value: string | undefined;
  onChange: (vendorId: string | undefined) => void;
  vendors: LabVendor[];
}

export function LabVendorFilter({ value, onChange, vendors }: LabVendorFilterProps) {
  const options = [
    { value: ALL, label: 'All vendors' },
    ...vendors.map((v) => ({ value: v.id, label: labVendorOptionLabel(v) })),
  ];
  return (
    <div className="w-56">
      <Select<string>
        id="lab-desk-vendor-filter"
        size="compact"
        aria-label="Lab vendor"
        options={options}
        value={value ?? ALL}
        onChange={(v) => onChange(v === ALL ? undefined : v)}
      />
    </div>
  );
}
